class Calendar {
  constructor({ date, lang, min = new Date(1990, 0, 1), max = new Date() }) {
    this.defaultData = {
      changedDay: !!date,
      changedMonth: !!date,
      changedYear: !!date,
    };
    this._date = null;
    this._lang = lang;
    this.min = typeof min === 'string' ? new Date(min) : min;
    this.max = typeof max === 'string' ? new Date(max) : max;

    if (!(date instanceof Date) && date) {
      this.date = new Date(date);
    } else {
      this.date = new Date(max);
    }
    this.observers = [];

    this.translate = {
      months: {
        ru: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь',
        ],
        ua: [
          'Січень',
          'Лютий',
          'Березень',
          'Квітень',
          'Травень',
          'Червень',
          'Липень',
          'Серпень',
          'Вересень',
          'Жовтень',
          'Листопад',
          'Грудень',
        ],
        en: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'Жовтень',
          'November',
          'December',
        ],
        pl: [
          'Styczeń',
          'Luty',
          'Marzec',
          'Kwiecień',
          'Maj',
          'Czerwiec',
          'Lipiec',
          'Sierpień',
          'Wrzesień',
          'Październik',
          'Listopad',
          'Grudzień',
        ],
      },
    };
  }

  set date(value) {
    this._date = value;
  }

  get date() {
    return this._date;
  }

  _fillArray(from, to) {
    const arr = [];

    for (let i = from; i <= to; i++) {
      arr.push(i);
    }

    return arr;
  }

  /** getters * */

  getLastDayInMonth(date) {
    return 33 - new Date(date.getFullYear(), date.getMonth(), 33).getDate();
  }

  getArrayDaysInMonth() {
    const lastDay = this.getLastDayInMonth(this.date);

    return this._fillArray(1, lastDay);
  }

  getArrayYears() {
    const min = this.min.getFullYear();
    const max = this.max.getFullYear();

    return this._fillArray(min, max);
  }

  getArrayMonths() {
    const month = this._fillArray(1, 12);
    if (!this._lang) {
      return month;
    }
    return month.map((el, i) => this.translate.months[this._lang][i]);
  }

  getCurrentDay() {
    return this.defaultData.changedDay ? this.date.getDate() : '';
  }

  getCurrentMonth() {
    const month = this.date.getMonth();

    if (!this._lang) {
      return month + 1;
    }
    return this.defaultData.changedMonth ? this.translate.months[this._lang][month] : '';
  }

  getDateString() {
    return this.date.toLocaleString('uk-UA', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  getCurrentYear() {
    return this.defaultData.changedYear ? this.date.getFullYear() : '';
  }

  /** setters * */

  setDay(day) {
    this.date.setDate(day);
    this.broadcast();
    this.defaultData.changedDay = true;
  }

  setMonth(month) {
    this.date.setMonth(month);
    this.broadcast();
    this.defaultData.changedMonth = true;
  }

  setYear(year) {
    this.date.setFullYear(year);
    this.broadcast();
    this.defaultData.changedYear = true;
  }

  /** observer * */

  subscribe(func) {
    this.observers.push(func);
  }

  unsubscribe(func) {
    this.observers = this.observers.filter((el) => el !== func);
  }

  broadcast() {
    if (this.observers?.length) {
      this.observers.forEach((func) => func(this));
    }
  }
}

export default Calendar;
